<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">APP推薦模塊</div>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd($route.query.id)">新增</div>
                    <div class="pg-btn" @click="$router.back()">返回</div>
                </div>
            </div>
            <Table size="small"
                   no-data-text="暫無數據"
                   border
                   maxHeight="680"
                   :columns="table.column"
                   :data="table.data">
                
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEditModal($route.query.id,row.id)">修改</div>
                        <div class="pg-btn style1" @click="handleDelete(row)">删除</div>
                    </div>
                </template>
                
                <template slot-scope="{ row, index }" slot="img">
                    <div v-if="row.image_path" class="demo-image__preview">
                        <el-image
                            style="width: 50px; height: 50px"
                            :src="row.image_path"
                            :preview-src-list="[row.image_path]">
                        </el-image>
                    </div>
                    <div v-else>无</div>
                </template>
                
                <template slot="status" slot-scope="{row,index}">
                        <Switchs true-color="#51f4a9" v-model="row.image_staus" @on-change="statusChange(row)"/>
                </template>

            </Table>

        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                isSubmiting: false,
                table: {
                    column: [
                        /*c_id: 21
                        id: 6
                        image_path: "https://dss2.bdstatic.com/5bVYsj_p_tVS5dKfpU_Y_D3/res/r/image/2021-3-4/hao123%20logo.png"
                        image_staus: 1
                        image_url: "33"
                        sort: 1*/
                        {
                            title: '活動圖片',
                            key: 'image_path',
                            align: 'center',
                            slot: 'img',
                            sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '跳轉鏈接',
                            key: 'image_url',
                            align: 'center',
                            minWidth: 80
                        },{
                            title: '是否開啓',
                            key: 'image_staus',
                            align: 'center',
                            slot: 'status',
                            minWidth: 80
                        },{
                            title: '排序',
                            key: 'sort',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 150
                        },
                    ],
                    data: []
                },
            };
        },
        activated() {
        
        },
        created() {
            
            this.getList();
        },

        methods: {
            // 开启 关闭
            statusChange(item) {
                console.log(item)
                let id = item.id, status = item.image_staus ? '1' : '0';
                this.isSubmiting = true;
        
                this.$Rq.requestAuth({
                    url: this.$Api.appRecommendedSetStatus,
                    method: 'post',
                    data: {
                        id,
                        type: 2,
                        status
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    this.$Utils.showSuccess(res.msg);
                    if (res.code === 0) {
                        this.getList();
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
    
            // 列表
            getList() {
                this.isSubmiting = true;
                let id = this.$route.query.id
                this.$Rq.requestAuth({
                    url: `${this.$Api.appRecommendedManageList}?id=${id}`,
                    method: 'get',
                }).then((res) => {
                    this.isSubmiting = false;
                    this.$Utils.showSuccess(res.msg);
                    if (res.code == 0) {
                        this.table.data = res.data.data[0].carousel_info.map(item => {
                            item.image_staus = item.image_staus == 1
                            return item
                        })
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
    
            // 删除
            handleDelete(item) {
                let id = item.id;
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定刪除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () => {
                        this.isSubmiting = true;
                        this.$Rq.requestAuth({
                            url: this.$Api.appRecommendedDel,
                            method: 'post',
                            data: {id}
                        }).then((res) => {
                            this.isSubmiting = false;
                            this.$Utils.showSuccess(res.msg);
                            if (res.code == 0) {
                                this.getList();
                            }
                        }).catch((err) => {
                            this.isSubmiting = false;
                            this.$Utils.showSuccess('网络异常');
                        });
                    }
                });
            },
    
            // 弹出 修改
            handleEditModal(pid,cid) {
                this.handleToAdd(pid,cid,1)
            },
    
            // 弹出新增
            handleToAdd(pid = '',cid = '',type = 0) {
                this.$router.push({path: `/recommendedEdit?pid=${pid}&cid=${cid}&type=${type}`});
            },

        }
    };
</script>

<style lang="scss" scoped>
    @import 'recommendedAdd.scss';
</style>
